import {
  Box,
  Chip,
  FormControl,
  FormHelperText,
  Grid,
  GridSize,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent
} from '@mui/material';
import React from 'react';

interface Option {
  value: string;
  label: string;
}

interface SelectProps {
  options: Option[];
  label: string;
  name: string;
  helperText?: string;
  fullWidth?: boolean;
  multiple?: boolean;
  required?: boolean;
  disableChip?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>, child: React.ReactNode) => void;
  error?: { message: string };
  /** Responsive column widths of the wrapping Grid item. */
  xs?: GridSize;
  sm?: GridSize;
  md?: GridSize;
  lg?: GridSize;
}

function SelectInput({
  name,
  label,
  options,
  fullWidth,
  multiple,
  required,
  disableChip,
  value,
  onChange,
  error,
  xs = 12,
  sm = 12,
  md = 4,
  lg,
  ...extraProps
}: SelectProps) {
  return (
    <Grid item xs={xs} sm={sm} md={md} lg={lg} style={{ width: '100%' }}>
      <FormControl fullWidth sx={{ mb: 3 }} size="small">
        <InputLabel required={required} id={`simple-${name}-label`}>
          {label}
        </InputLabel>

        <Select
          name={name}
          multiple={multiple}
          input={<OutlinedInput id="select-multiple-chip" label={label} />}
          renderValue={(selected: string | string[]) => {
            const items = options.filter((item: Option) =>
              multiple ? selected.includes(item.value) : selected === item.value
            );

            return (
              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 0.5
                }}
              >
                {items.map(({ value, label }: Option) => {
                  return disableChip ? (
                    label
                  ) : (
                    <Chip key={value} label={label} sx={{ height: 'auto' }} />
                  );
                })}
              </Box>
            );
          }}
          labelId={`simple-${name}-label`}
          id={name}
          onChange={onChange}
          value={value}
          label={label}
          variant="outlined"
          fullWidth={fullWidth}
          size="small"
          //   required={required}
          {...extraProps}
        >
          {options.map((option: Option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>

        <FormHelperText sx={{ color: 'red', marginLeft: 0 }}>{error?.message || ''}</FormHelperText>
      </FormControl>
    </Grid>
  );
}

export default SelectInput;
